import { useState } from "react";
import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import Pagination from "components/ui/pagination/Pagination";

export default function FilteredDataTable({ data }) {
  const { t } = useTranslation();

  /* --------------------------------------------- Start Pagination  -----------------------------------------------*/
  const recordsPerPage = 10;
  const [currentPageActive, setCurrentPageActive] = useState(1);
  const prePage = (currentPage, setCurrentPage) => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = (currentPage, setCurrentPage, npage) => {
    if (currentPage < npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const calculateRecords = (data, currentPage, recordsPerPage) => {
    const firstIndex = (currentPage - 1) * recordsPerPage;
    const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
    return data?.slice(firstIndex, lastIndex);
  };

  // Calculate records for activeDiscounts
  const itemsFilteredData = calculateRecords(
    data,
    currentPageActive,
    recordsPerPage
  );
  /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return (
    <>
      <>
        <Table>
          <Thead>
            <Tr>
              <Th>#</Th>
              <Th>{t("pages.reports.reports_tables.name")}</Th>
              <Th>{t("pages.reports.reports_tables.sku")}</Th>
              <Th>{t("pages.reports.reports_tables.storage_unit")}</Th>
              <Th>{t("pages.reports.reports_tables.purchase_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.purchase_cost")}</Th>
              <Th>{t("pages.reports.reports_tables.returned_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.returned_cost")}</Th>
              <Th>{t("pages.reports.reports_tables.net_quantity")}</Th>
              <Th>{t("pages.reports.reports_tables.net_cost")}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {itemsFilteredData?.map((item, index) => (
              <Tr key={item?.InventoryItemId}>
                <Td>{index + 1}</Td>
                <Td>{item?.InventoryItemNameEng}</Td>
                <Td>{item?.Ref}</Td>
                <Td>{item?.StorageUnit}</Td>
                <Td>{item?.PurchaseQuantity}</Td>
                <Td>{item?.PurchaseCost}</Td>
                <Td>{item?.ReturnedQuantity}</Td>
                <Td>{item?.ReturnedCost}</Td>
                <Td>{item?.NetQuantity}</Td>
                <Td>{item?.NetCost}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        <Pagination
          currentPage={currentPageActive}
          setCurrentPage={setCurrentPageActive}
          npage={Math.ceil(data?.length / recordsPerPage)}
          prePage={() => prePage(currentPageActive, setCurrentPageActive)}
          nextPage={() =>
            nextPage(
              currentPageActive,
              setCurrentPageActive,
              Math.ceil(data?.length / recordsPerPage)
            )
          }
        />
      </>
    </>
  );
}
